import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ITimeSeriesRow } from "../models/IProductModelTimeSeriesTableProps";

const formatValue = (value: number | null | undefined) => {
	if (value === null || value === undefined) return "-";
	return Number(value.toFixed(2)).toLocaleString();
};

export const useProductModelTimeSeriesHeaders = (
	primaryLabel?: string,
	benchmarkLabel?: string
) => {
	const { t } = useTranslation();

	const headers = useMemo(() => {
		const cols = [
			{
				key: "date",
				id: (row: ITimeSeriesRow) => row.date,
				name: t("date"),
				width: 150,
			},
			{
				key: "real",
				id: (row: ITimeSeriesRow) => formatValue(row.real),
				name: t("real"),
				width: 150,
			},
		];

		if (primaryLabel) {
			cols.push({
				key: "model1",
				id: (row: ITimeSeriesRow) => formatValue(row.model1),
				name: primaryLabel,
				width: 200,
			});
		}

		if (benchmarkLabel) {
			cols.push({
				key: "model2",
				id: (row: ITimeSeriesRow) => formatValue(row.model2),
				name: benchmarkLabel,
				width: 200,
			});
		}

		const groupedCols = [
			{
				id: () => "timeseriesGroup",
				name: t("timeSeriesDetails"),
				headers: cols,
			},
		];

		return groupedCols;
	}, [t, primaryLabel, benchmarkLabel]);

	return { headers };
};
